export default __webpack_public_path__ + "static/media/circle1-jp.2e186bc3.svg";